import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui/button';
import { RefreshCw, X } from 'lucide-react';

/**
 * PWAUpdatePrompt - Yeni service worker hazır olduğunda kullanıcıya
 * "Aktualisierung verfügbar" bildirimi gösterir.
 *
 * vite-plugin-pwa autoUpdate modunda yeni SW arka planda kurulur ve
 * kullanıcıdan onay almadan etkinleşir; bu prompt, kullanıcı onayıyla
 * sayfayı yeniden yükleyerek yeni versiyona geçer.
 */
export default function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl) {
      // Service worker kayıtlı — sessizce çalışır
    },
    onRegisterError(error) {
      // Sessiz başarısızlık — SW olmadan da app çalışır
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-[100] bg-brand-950 text-white rounded-xl shadow-2xl p-4 border border-white/10 animate-in slide-in-from-bottom-4 fade-in"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-amber-400/20 flex items-center justify-center flex-shrink-0">
          <RefreshCw className="w-4 h-4 text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold">Neue Version verfügbar</p>
          <p className="text-xs text-white/60 mt-0.5">
            Aktualisieren Sie, um die neuesten Funktionen zu erhalten.
          </p>
          <div className="flex gap-2 mt-3">
            <Button
              size="sm"
              onClick={() => updateServiceWorker(true)}
              className="h-9 bg-amber-500 hover:bg-amber-600 text-brand-950 font-semibold"
            >
              Aktualisieren
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => setNeedRefresh(false)}
              className="h-9 text-white/60 hover:text-white hover:bg-white/10"
            >
              Später
            </Button>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setNeedRefresh(false)}
          className="text-white/40 hover:text-white/80 transition-colors p-1"
          aria-label="Schließen"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
